import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const bannerListApi = async (data) => {
  const endPoint = `/admin/banners?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------add Brands-listing--------------------------
export const addBannerApi = async (data) => {
  const endPoint = `/admin/banners`;

  return await axios.post(endPoint, data, setJwtToken());
};

// ---------fetch selected banner

export const getSelectedBanner = async (id) => {
  const endPoint = `/admin/banners/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// ---------------------Edit Brands-listing--------------------------
export const editBannerApi = async ({ image, position, sequence, selectedBanner }) => {
  const endPoint = `/admin/banners/${selectedBanner}`;

  return await axios.put(endPoint, { image, position, sequence }, setJwtToken());
};

// ---------Delete selected banner

export const deleteSelectedBanner = async (id) => {
  const endPoint = `/admin/banners/${id}`;

  return await axios.delete(endPoint, setJwtToken());
};

// ---------change selected banner Status

export const changeSelectedBannerStatus = async ({ id, status }) => {
  const endPoint = `/admin/banners/${id}`;

  return await axios.patch(endPoint, { status }, setJwtToken());
};
